import { Dropdown, Tooltip, Modal } from 'bootstrap'
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))
import { Spinner } from "./loandig";




if (document.querySelector('#inquire')) {
  var myModal = new Modal('#inquire', {
    keyboard: false
  })

  const btnopenmodal = document.querySelector('#openmodal');
  const btn_submit = document.querySelector('.btn-subtmit')
  btnopenmodal.addEventListener('click', () => {
    myModal.show();
  })
}
const form = document.querySelector('#id_travelling');
const loandig = new Spinner({
  selector: ".loandig",
  width: 25,
  height: 25,
  text: "loandig..",
  color: "#d7b672",
  background: "#fff",
});
if (form) {
  const url = form.getAttribute('action')
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    loandig.active()
    const formdata = new FormData(form);
    fetch(url, { method: 'POST', body: formdata })
      .then(res => res.json())
      .then(data => {
        let { error, status, message } = data;
        if (status === 200) {
          alert(message)
          loandig.hide();
          myModal.hide()
        } else {
          loandig.hide()
          console.log(message)
        }
      })
  })
}


// PAGE CONTACT US
// const loandigS= new Spinner({
//   selector: ".loandig",
//   width: 25,
//   height: 25,
//   text: "loandig..",
//   color: "#d7b672",
//   background: "#fff",
// });

// // CONTACT FORM ORANGE
// const cform=document.querySelector('#contact_form');
// if(cform){
//   cform.addEventListener('submit',(e)=>{
//     e.preventDefault();
//     loandig.active()
//     let CDB=new FormData(cform)
//     fetch(cform.getAttribute('action'),{method: 'POST',body:CDB})
//     .then(res=>res.json())
//     .then(data=>{
//       let {error,status,message}=data;
//       if(status==200){
//         loandig.hide();
//         cform.reset()
//         alert(message)
//       }else{
//         loandig.hide();
//         console.log(data);
//         alert(message)
//       }
//     })
//     .catch(err=>{
//       loandig.hide()
//       console.error(err)
//     })
//   })
// }
// CONTACT FORM NEW SCRIPT PAGE
console.log(PEARSCRIPT)
const fromContact = document.getElementById('contact_form');
const load = new Spinner({
  selector: ".loandig",
  width: 25,
  height: 25,
  text: "loandig..",
  color: "#d7b672",
  background: "#fff",
});
if (fromContact) {
    // Crea un nuevo objeto Contact utilizando el elemento de formulario fromContact
   fromContact.addEventListener('submit',(e)=>{
      e.preventDefault()
      load.active()
    const peardata = new FormData(fromContact);
    peardata.append('pear_hook', PEARSCRIPT.pear_hook);    
    peardata.append('action', PEARSCRIPT.action_contact);
    fetch(PEARSCRIPT.ajax_url, { method: 'POST', body: peardata })
    .then(response => {
        if (response.ok) {
            return response.json();
        } else {
          load.hide()
            throw new Error('La solicitud no fue exitosa');
        }
    })
    .then(data => {
        if(data.success) {
          load.hide()
          fromContact.reset()
          Swal.fire({
            title: data.data.title,
            text:  data.data.message,
            icon: "success",
            showCancelButton: false,
            showConfirmButton:false,
            showCloseButton: true,
          });
        }else if(data.data.status==500) {
          load.hide()
          Swal.fire({
            title: data.data.title,
            text:  data.data.message,
            icon: "error",
            showCancelButton: false,
            showConfirmButton:false,
            showCloseButton: true,
          });
        }else{
          load.hide()
          fromContact.reset()
          Swal.fire({
            title: data.data,
            text: null,
            icon: "error",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'Update',
            showCloseButton: true,
            confirmButtonColor: '#000', // Cambia esto al color que desees
            customClass: {
              confirmButton: ' btn-sm rounded-0 shadow-0' // Agrega aquí la clase personalizada que quieras
            }
          }).then((result) => {
            if (result.isConfirmed) {
              location.reload(); // Esto recarga la página
            }
          });
                 
        }        
    })
    .catch(error => {
        console.error('Error en la solicitud:', error);      
        if (error && error.message) {
            console.error('Mensaje de error del servidor:', error.message);
        }
    });
   })
}

// add recapcha
window.addEventListener('DOMContentLoaded',()=>{
    // Função para gerar o token do reCAPTCHA v3
    function generateRecaptchaToken() {
      grecaptcha.ready(function() {
          // Substitua SEU_SITE_KEY pelo site key fornecido pelo Google reCAPTCHA
          grecaptcha.execute('6LfE_68mAAAAAA_prlPi5JEMeG_MH6Vrad93ma6w', {
              action: 'submit'
          }).then(function(token) {
              // Atribua o token ao campo oculto
              if(document.getElementById('recaptchaToken')){
                 document.getElementById('recaptchaToken').value = token;
              }
          });
      });
  }

  // Chame a função ao carregar a página
  generateRecaptchaToken();
})


// script read more

var postContainers = document.querySelectorAll(
  'div.content-read div.readmore');
if (postContainers) {
  postContainers.forEach(function (container) {
    var Hval = container.clientHeight;
    var Hval_P = container.parentElement.clientHeight;

    if (Hval > Hval_P) {
      container.parentElement.querySelector('div#fade').style
        .display = 'block';
      container.parentElement.querySelector('span#more').style
        .display = 'block';
    }
  });

  var moreButtons = document.querySelectorAll('span#more');

  moreButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var container = this.parentElement
        .querySelector('div.readmore');
      var Hval = container.clientHeight;
      var Hval_P = this.parentElement.clientHeight;


      this.parentElement.style.maxHeight = '100%';
      this.style.display = 'none';
      this.parentElement.querySelector('div#fade')
        .style.display = 'none';
      this.parentElement.querySelector('span#less')
        .style.display = 'block';
    });
  });


  var lessButtons = document.querySelectorAll('span#less');
  lessButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      this.parentElement.style.maxHeight = '180px';
      this.style.display = 'none';
      this.parentElement.querySelector('div#fade')
        .style.display = 'block';
      this.parentElement.querySelector('span#more').style
        .display = 'block';
    });
  });
}
    document.addEventListener("DOMContentLoaded", function() {
      var ur = document.getElementById("stickycontent");
      
      window.addEventListener("scroll", function() {
          if (ur) {
           
              var stickyElement = ur.querySelector(".sticky");
              if (stickyElement) {
                  if (ur.getBoundingClientRect().bottom >= window.innerHeight) {
                      stickyElement.classList.add("isActive");
                  } else {
                      stickyElement.classList.remove("isActive");
                  }
              }
          }
      });
  });

